import React, { useMemo, useState } from "react";
import axios from "axios";
import { BACKEND_URL } from "../../constants";

export const SystemAdminLogin = () => {
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [authenticated, setAuthenticated] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [search, setSearch] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const verifyPasswords = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axios.post(
        `${BACKEND_URL}/system-admin-login`,
        {
          password1,
          password2,
        }
      );

      if (response.data.status !== "success") {
        setError(
          response.data.errorText ||
            "Fel lösenord"
        );
        return;
      }

      setAuthenticated(true);
      setCompanies(
        response.data.companies || []
      );
    } catch (err) {
      console.log(err);
      setError(
        "Kunde inte ansluta till servern"
      );
    } finally {
      setLoading(false);
    }
  };

  const loginAsCompany = async (
    companyId
  ) => {
    try {
      const response = await axios.post(
        `${BACKEND_URL}/system-admin-login-as-company`,
        {
            companyId,
            password1,
            password2,
        },
        {
            withCredentials: true,
        }
      );

      if (
        response.data.status !== "success"
      ) {
        alert(
          response.data.errorText ||
            "Kunde inte logga in"
        );
        return;
      }

      console.log(
        "Inloggad i företag:",
        companyId
      );
      window.location.href = "/";

      // localStorage.setItem("token", response.data.token);
      // window.location.href = "/";
    } catch (err) {
      console.log(err);
      alert("Serverfel");
    }
  };

  const filteredCompanies = useMemo(() => {
    return companies.filter((company) =>
      `${company.name || ""} ${
        company.orgNumber || ""
      }`
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  }, [companies, search]);

  if (!authenticated) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background:
            "linear-gradient(135deg,#eef2ff,#f8fafc)",
          padding: "32px",
          marginLeft: -240
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "520px",
            background: "#fff",
            borderRadius: "28px",
            padding: "48px",
            boxShadow:
              "0 25px 80px rgba(0,0,0,0.08)",
            border:
              "1px solid rgba(0,0,0,0.05)",
          }}
        >
          <div
            style={{
              textAlign: "center",
              marginBottom: "40px",
            }}
          >
            <div
              style={{
                width: "72px",
                height: "72px",
                borderRadius: "18px",
                background:
                  "linear-gradient(135deg,#2563eb,#4f46e5)",
                margin: "0 auto 20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
                fontWeight: 800,
                fontSize: "24px",
              }}
            >
              SA
            </div>

            <h1
              style={{
                margin: 0,
                color: "#111827",
                fontSize: "36px",
                fontWeight: 800,
              }}
            >
              System Admin
            </h1>

            <p
              style={{
                marginTop: "10px",
                color: "#64748b",
              }}
            >
              Verifiera åtkomst för att
              visa alla företag
            </p>
          </div>

          <input
            type="password"
            placeholder="Lösenord 1"
            value={password1}
            onChange={(e) =>
              setPassword1(
                e.target.value
              )
            }
            style={{
              width: "100%",
              height: "58px",
              borderRadius: "14px",
              border: "1px solid #dbe2ea",
              padding: "0 18px",
              marginBottom: "14px",
              fontSize: "15px",
              boxSizing: "border-box",
            }}
          />

          <input
            type="password"
            placeholder="Lösenord 2"
            value={password2}
            onChange={(e) =>
              setPassword2(
                e.target.value
              )
            }
            style={{
              width: "100%",
              height: "58px",
              borderRadius: "14px",
              border: "1px solid #dbe2ea",
              padding: "0 18px",
              marginBottom: "18px",
              fontSize: "15px",
              boxSizing: "border-box",
            }}
          />

          {error ? (
            <div
              style={{
                background:
                  "#fef2f2",
                color: "#dc2626",
                border:
                  "1px solid #fecaca",
                padding: "12px",
                borderRadius: "12px",
                marginBottom: "18px",
                textAlign: "center",
              }}
            >
              {error}
            </div>
          ) : null}

          <button
            onClick={verifyPasswords}
            disabled={loading}
            style={{
              width: "100%",
              height: "58px",
              border: "none",
              borderRadius: "14px",
              background:
                "linear-gradient(135deg,#2563eb,#4f46e5)",
              color: "#fff",
              fontSize: "16px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            {loading
              ? "Verifierar..."
              : "Logga in"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(180deg,#f8fafc,#eef2ff)",
        padding: "40px",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: "40px",
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: "42px",
              color: "#111827",
              fontWeight: 800,
            }}
          >
            Alla företag
          </h1>

          <p
            style={{
              color: "#64748b",
              marginTop: "10px",
            }}
          >
            {
              filteredCompanies.length
            }{" "}
            företag hittades
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "32px",
          }}
        >
          <input
            type="text"
            placeholder="Sök företag..."
            value={search}
            onChange={(e) =>
              setSearch(
                e.target.value
              )
            }
            style={{
              width: "100%",
              maxWidth: "700px",
              height: "58px",
              borderRadius: "16px",
              border:
                "1px solid #dbe2ea",
              padding: "0 20px",
              fontSize: "15px",
              boxSizing: "border-box",
              background: "#fff",
            }}
          />
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fill,minmax(320px,1fr))",
            gap: "20px",
          }}
        >
          {filteredCompanies.map(
            (company) => (
              <div
                key={company._id}
                style={{
                  background:
                    "#ffffff",
                  borderRadius:
                    "20px",
                  padding: "24px",
                  boxShadow:
                    "0 10px 30px rgba(0,0,0,0.05)",
                  border:
                    "1px solid #eef2f7",
                }}
              >
                <div
                  style={{
                    width: "58px",
                    height: "58px",
                    borderRadius:
                      "14px",
                    background:
                      "linear-gradient(135deg,#2563eb,#4f46e5)",
                    color: "#fff",
                    display: "flex",
                    justifyContent:
                      "center",
                    alignItems:
                      "center",
                    fontWeight: 800,
                    fontSize: "20px",
                    marginBottom:
                      "18px",
                  }}
                >
                  {(
                    company.name ||
                    "F"
                  )
                    .charAt(0)
                    .toUpperCase()}
                </div>

                <h3
                  style={{
                    margin: 0,
                    color:
                      "#111827",
                    fontSize:
                      "20px",
                  }}
                >
                  {company.name}
                </h3>

                <p
                  style={{
                    color:
                      "#64748b",
                    marginTop:
                      "8px",
                    marginBottom:
                      "20px",
                  }}
                >
                  {
                    company.orgNumber
                  }
                </p>

                <button
                  onClick={() =>
                    loginAsCompany(
                      company._id
                    )
                  }
                  style={{
                    width: "100%",
                    height: "50px",
                    border: "none",
                    borderRadius:
                      "12px",
                    background:
                      "#2563eb",
                    color:
                      "#ffffff",
                    fontWeight: 700,
                    cursor:
                      "pointer",
                  }}
                >
                  Logga in som företag
                </button>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default SystemAdminLogin;